import React from 'react';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import publishInterruptionTypes from '../constants/publish-interruption-types';

const { Paragraph } = designSystem;

const getPublishInterruptionOptions = () => [
  {
    id: publishInterruptionTypes.PUBLISH,
    withDecoration: true,
    title: (
      <Paragraph size="large">
        <b>{i18next.t('Publish to a domain')}</b>
      </Paragraph>
    ),
    description: i18next.t('Select a domain name and hosting package to take you business online'),
  },
  {
    id: publishInterruptionTypes.PREVIEW,
    title: (
      <Paragraph size="large">
        <b>{i18next.t('Not ready yet?')}</b> {i18next.t('Preview your website for free!')}
      </Paragraph>
    ),
  },
];

export default getPublishInterruptionOptions;
